module.exports = __webpack_public_path__ + "static/img/exgs.f3fef26.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/exgs.png
// module id = ZWjn
// module chunks = 1